import { render } from "./klikpajak.svg?vue&type=template&id=6e0a77a1"
const script = {}
script.render = render

export default script